import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const inputStyles = (theme = {}) => ({
  withAnimatedLabel: {
    minWidth: '40px',

    '& label.Mui-focused': {
      color: 'var(--primary-v2)',
    },

    '& .MuiInput-underline:after': {
      borderBottomColor: 'var(--primary-v2)',
    },

    '& .MuiOutlinedInput-root': {
      fontSize: '1rem',

      '& fieldset': {
        borderColor: 'var(--primary-v2)',

        '& legend': {
          fontSize: '0.62em',
        },
      },
      '&:hover fieldset': {
        borderColor: 'var(--dark-grey)',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'var(--primary-v2)',
      },
    },

    '& .MuiInputLabel-outlined': {
      fontSize: '0.875rem',

      '&.MuiInputLabel-marginDense:not(.MuiInputLabel-shrink)': {
        transform: `translate(14px, 14px) scale(1)`,
      },

      '&.MuiInputLabel-shrink': {
        transform: `translate(14px, -4px) scale(0.75)`,
      }
    }
  },
  withAnimatedLabelAndError: {
    minWidth: '40px',

    '& label.Mui-focused': {
      color: 'var(--error)',
    },

    '& .MuiInput-underline:after': {
      borderBottomColor: 'var(--error)',
    },

    '& .MuiOutlinedInput-root': {
      fontSize: '1rem',

      '& fieldset': {
        borderColor: 'var(--error)',

        '& legend': {
          fontSize: '0.62em',
        },
      },
      '&:hover fieldset': {
        borderColor: 'var(--dark-grey)',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'var(--error)',
      },
    },

    '& .MuiInputLabel-outlined': {
      fontSize: '0.875rem',

      '&.MuiInputLabel-marginDense:not(.MuiInputLabel-shrink)': {
        transform: `translate(14px, 14px) scale(1)`,
      },

      '&.MuiInputLabel-shrink': {
        transform: `translate(14px, -4px) scale(0.75)`,
      }
    }
  },
});

const useStyles = makeStyles(inputStyles({}));

export const Input = ({
  label = '',
  name,
  value,
  type = 'text',
  size = 'small',
  variant = 'outlined',
  error = false,
  disabled = false,
  required = false,
  // @todo the message can be replaced with helperText
  message = '',
  placeholder = '',
  helperText = '',
  autoFocus = false,
  style = {},
  InputProps = {},
  onChange: handleChange = () => {},
  onKeyDown: handleKeyDown = () => {}
}) => {
  const classes = useStyles();

  const InputClassName = new Map([
    [false, classes.withAnimatedLabel],
    [true, classes.withAnimatedLabelAndError],
  ]);

  const MessageClassName = new Map([
    [false, 'color-primary-v2'],
    [true, 'color-error'],
  ]);

  return (
    <div className='flex flex-column'>
      <TextField
        name={name}
        label={label}
        variant={variant}
        size={size}
        disabled={disabled}
        required={required}
        type={type}
        className={InputClassName.get(!!error)}
        style={style}
        autoFocus={autoFocus}
        value={value}
        error={error}
        helperText={helperText}
        InputProps={InputProps}
        placeholder={placeholder}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />

      {
        message.length > 0 && (
          <div className={`flex font-12 m-t-1 m-b-1 ${MessageClassName.get(!!error)}`}>
            <span>{message}</span>
          </div>
        )
      }
    </div>
  );
}

export default Input;
